import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.utkarsita.com/api/v1',
    prepareHeaders: async (headers, { getState }) => {
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Product'],
  endpoints: (builder) => ({
    getProductsBySlug: builder.query({
      query: (slug) => `/products/${slug}`, // Adjust the path according to your backend API
      providesTags: ['Product'],
    }),
    getAllCollection: builder.query({
      query: () => ({
        url: `/get/AllCollections`, // Adjust the path according to your backend API
        method: 'GET',
      }),
      providesTags: ['Collection'],
    }),
    getAllProducts: builder.query({
      query: () => ({
        url: '/list/products',
        method: 'GET',
      }), // Assuming your endpoint for all products is '/products'
      providesTags: ['Product'],
    }),
    getProductsBySearch: builder.query({
      query: (searchQuery) => `/products/pl/search?q=${searchQuery}`, // Adjust the path for search API
      providesTags: ['Product'],
    }),
    getCourierServiceability: builder.query({
      query: (deliveryPostcode) => `/shipment/courier-serviceability?pickup_postcode=755003&delivery_postcode=${deliveryPostcode}&cod=1&weight=2.5&mode=Air`, // Adjust the path for search API
      providesTags: ['Product'],
    }),
    getProductDetails: builder.query({
      query: (slug) => ({
        url: `/product/${slug}`,
        method: 'GET',
      }),
      providesTags: ['Product'],
    }),
    getAllCollections: builder.query({
      query: () => ({
        url: `/get/AllCollections`,
        method: 'GET',
      }),
      providesTags: ['Collection'],
    }),
    getProductsByCollection: builder.query({
      query: (collectionSlug) => ({
        url: `/${collectionSlug}`,
        method: 'GET',
      }),
      providesTags: ['Product'],
    }),
    getSearchProducts: builder.query({
      query: ({ searchQuery }) => ({
        url: `/product/search?query=${searchQuery}`,
        method: 'GET',
      }),
      providesTags: ['Product'],
    }),
    getCourierDeliveryExpectedTime: builder.query({
      query: (userPincode) => ({
        url: `/shipment/serviceability-bluedart?pickup_postcode=751024&delivery_postcode=${userPincode}&cod=1&weight=2.5&mode=Air`,
        method: 'GET',
      }),
      providesTags: ['Product'],
    }),
  }),
});

export const {
  useGetProductsBySlugQuery,
  useGetProductDetailsQuery,
  useGetAllCollectionQuery,
  useGetAllProductsQuery,
  useGetProductsBySearchQuery,
  useGetProductsByCollectionQuery,
  useGetSearchProductsQuery,
  useLazyGetCourierServiceabilityQuery,
  useLazyGetCourierDeliveryExpectedTimeQuery
} = productApi;
